import { React, useEffect, useState }  from "react";
import { useParams, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import Loader from "./Loader";
import moment from "moment";
import { PortableText } from "@portabletext/react";
import createClient from '../Client';
import {Footer } from "../components";

const serializers = {

  marks: {

    link: ({children, value}) => {

      const rel = !value.href.startsWith('/') ? 'noreferrer noopener' : undefined

      const target = '_blank'
      const className = 'link'

      return (

        <a href={value.href} rel={rel} target={target} className={className}>

          {children}

        </a>

      )

    },

  },

};
//news detail page
const NewsSinglePost=(setLoading, footerData, items ) => {
  const[blogContentItem, setblogContentItem] = useState([])
    const params = useParams();
    const location = useLocation();
    const slugId = location.pathname.split('news/')[1];

    // const [loading, setLoading] = useState(true);
    const [loadingNews, setLoadingNews] = useState(true); 

  useEffect(() => {
    
    // setTimeout(() => {
      setLoading(false);
    // }, 300); 
  }, []);

  
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [location]);

      useEffect(() => {
        setLoading(true); 
        createClient.fetch(`*[_type == 'news' && news_slug.current == "${slugId}"][0]{
        "id": _id,
        "image":news_featured_image.asset->url,
        "metaDate": news_release_date,
        "blogTitle":news_title,
        "blogDesc": news_description,
        "blogSlug": news_slug.current,
        "blogBannerImage":news_banner_image.asset->url,
        "blogbannerImageEnable":news_banner_check,
        "seoTitle": seo_title,
        "seoDescription": seo_description,
        "seoOgImage": seo_og_image.asset->url,
        }
          `).then((data) => {
            setblogContentItem(data);
            setLoadingNews(false); // Local loading complete
                setLoading(false); 
          })
        .catch((error) => {
          console.error(error);
          setLoadingNews(false); // Make sure the loader dissapears even on error
          setLoading(false);
      });
        // catch(console.error);
      
    }, [slugId, setLoading]);

    if (loadingNews) {
      return <Loader />; // Use local loading state
  }
    const pageTitle = blogContentItem.seoTitle || (blogContentItem.blogTitle ? `${blogContentItem.blogTitle} \u2014 OrthoPed` : "News \u2014 OrthoPed");
    const pageDescription = blogContentItem.seoDescription || "Read the latest news from OrthoPed \u2014 AI-powered remote monitoring for pediatric orthopedics.";
    const pageImage = blogContentItem.seoOgImage || blogContentItem.image || "https://www.orthoped.ai/logoImage.png";
    const canonicalUrl = `https://www.orthoped.ai/news/${blogContentItem.blogSlug || slugId}`;

    return (
       <>
       <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={pageImage} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={pageImage} />
        {blogContentItem.metaDate && (
          <meta property="article:published_time" content={blogContentItem.metaDate} />
        )}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: blogContentItem.blogTitle || "",
            image: blogContentItem.image ? [blogContentItem.image] : [],
            datePublished: blogContentItem.metaDate || "",
            author: { "@type": "Organization", name: "OrthoPed", url: "https://www.orthoped.ai" },
            publisher: {
              "@type": "Organization",
              name: "OrthoPed",
              logo: { "@type": "ImageObject", url: "https://www.orthoped.ai/logoImage.png" },
            },
            mainEntityOfPage: { "@type": "WebPage", "@id": canonicalUrl },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://www.orthoped.ai/" },
              { "@type": "ListItem", position: 2, name: "News", item: canonicalUrl },
            ],
          })}
        </script>
       </Helmet>

       {blogContentItem.blogbannerImageEnable ?
          <div className="container-fluid p-0">
            <div className='col-12'>
              <div className='row banner-wrapper-container' style={{ backgroundImage: `url(${blogContentItem.blogBannerImage})` }} role="img" aria-label={`Banner for ${blogContentItem.blogTitle || "news article"}`}>
              <div className="container banner-title-wrapper">
                <h2 className="heading-title">News</h2>
              </div>
              </div>
            </div>
          </div>

        :""}
       <section className="about news-detail-page" >
            <div className="container">
                <div className="row align-items-center text-center-xs">
                    <div className="col-12 col-lg-12">
                      <img className="img-fluid" src={blogContentItem.image} alt={blogContentItem.blogTitle || "News article featured image"} />
                        <div className="heading mb-40">
                            <p className="heading-subtitle">{moment(blogContentItem.metaDate).format('DD MMMM YYYY')}</p>
                            <h2 className="heading-title">{blogContentItem.blogTitle}</h2>
                            <span className="heading-desc"> <PortableText value={blogContentItem.blogDesc} components={serializers} ></PortableText></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         {!setLoadingNews && <Footer footerData={footerData} items={items}></Footer>}
       </>

    );
}
export default NewsSinglePost;